const CHUNK_SIZE = 64;
const CHUNK_GRID_SIZE = 8;
const RENDER_DISTANCE = 2;
const GEOM_TO_COLLISION_RATIO = 4.0;

const OCTAVES = 6;
const FREQUENCY = 0.01;
const LACUNARITY = 2.5;
const AMPLITUDE = 220.0;
const PERSISTENCE = 0.5;
const OFFSET = -200;

const SUN_OFFSET = { x: 10, y: 20, z: 10 };

const INTERFACE_WIDTH = 400;
const INTERFACE_HEIGHT = 300;

export { 
    CHUNK_SIZE, 
    CHUNK_GRID_SIZE, 
    RENDER_DISTANCE, 
    GEOM_TO_COLLISION_RATIO, 
    OCTAVES, 
    FREQUENCY, 
    LACUNARITY, 
    AMPLITUDE, 
    PERSISTENCE, 
    OFFSET, 
    SUN_OFFSET, 
    INTERFACE_WIDTH, 
    INTERFACE_HEIGHT 
};